var App = (function($) {
	"use strict";

	// ============================================
	// Header — burger toggle
	// ============================================
	var Header = (function() {
		function setOpen(open) {
			var $panel = $('[data-widget="menu-panel"]');

			$panel.toggleClass('is-open', open);
			$('[data-js="menu-open"]').attr('aria-expanded', open);
			$('body').toggleClass('menu-open', open);

			$panel.toggle(open);
		}

		function init() {
			if (!$('[data-widget="menu-panel"]').length) return;

			$(document).on('click', '[data-js="menu-open"]', function(e) {
				e.stopPropagation();
				setOpen(true);
			});

			$(document).on('click', '[data-js="menu-close"]', function() {
				setOpen(false);
			});

			// Clicks inside the panel must not reach the document handler below,
			// or the gaps between the rows would close it.
			$(document).on('click', '[data-widget="menu-panel"]', function(e) {
				e.stopPropagation();
			});

			$(document).on('click', function() {
				setOpen(false);
			});

			$(document).on('keydown', function(e) {
				if (e.key === 'Escape') setOpen(false);
			});

			// Sliding leaves an inline display behind, and the panel is a mobile
			// affordance — a phone-width session must not follow the viewport up
			// and leave it pinned over the desktop layout.
			var mq = window.matchMedia('(min-width: 1024px)');

			function release() {
				if (!mq.matches) return;
				$('[data-widget="menu-panel"]').removeAttr('style');
				setOpen(false);
			}

			if (mq.addEventListener) {
				mq.addEventListener('change', release);
			} else {
				mq.addListener(release);
			}

			release();
		}

		return { init: init };
	})();

	// ============================================
	// Page state — marks the current nav item and fills the mobile bar label
	// ============================================
	// HTML: <body data-page="shop.html" data-label="Shop">
	var PageState = (function() {
		function init() {
			var page = $('body').attr('data-page');
			if (!page) return;

			$('[data-js="page-label"]').text($('body').attr('data-label'));
			$('.site-header__nav, .menu-panel__nav, .site-footer__links')
				.find('a[href="' + page + '"]')
				.addClass('is-current');
		}

		return { init: init };
	})();

	// ============================================
	// Quantity stepper — cart lines
	// ============================================
	// HTML: <div class="item__qty" data-widget="qty">
	//         <button data-js="qty-down">–</button>
	//         <span data-js="qty-value">1</span>
	//         <button data-js="qty-up">+</button>
	//       </div>
	var Qty = (function() {
		function step($widget, delta) {
			var $value = $widget.find('[data-js="qty-value"]');
			var next = parseInt($value.text(), 10) + delta;
			if (isNaN(next) || next < 1) next = 1;
			$value.text(next);
		}

		function init() {
			if (!$('[data-widget="qty"]').length) return;

			$(document).on('click', '[data-js="qty-up"]', function() {
				step($(this).closest('[data-widget="qty"]'), 1);
			});

			$(document).on('click', '[data-js="qty-down"]', function() {
				step($(this).closest('[data-widget="qty"]'), -1);
			});
		}

		return { init: init };
	})();

	// ============================================
	// Info bar — mobile READ MORE toggle on detail pages
	// ============================================
	// HTML: <div class="block-detail__info" data-widget="info-bar">
	//         <p data-js="info-panel">…</p>
	//         <button data-js="info-toggle"
	//                 data-label-more="READ MORE +"
	//                 data-label-less="READ less –">READ MORE +</button>
	var InfoBar = (function() {
		var DESKTOP = '(min-width: 1024px)';

		function setOpen($bars, open) {
			$bars.each(function() {
				var $bar = $(this);
				var $toggle = $bar.find('[data-js="info-toggle"]');
				var $panels = $bar.find('[data-js="info-panel"]');

				$bar.toggleClass('is-open', open);
				$toggle.attr('aria-expanded', open);
				$toggle.text($toggle.data(open ? 'label-less' : 'label-more'));

				$panels.toggle(open);
			});
		}

		function init() {
			var $bars = $('[data-widget="info-bar"]');
			if (!$bars.length) return;

			$(document).on('click', '[data-js="info-toggle"]', function(e) {
				e.stopPropagation();
				var $bar = $(this).closest('[data-widget="info-bar"]');
				setOpen($bar, !$bar.hasClass('is-open'));
			});

			// Clicks inside the bar must not reach the document handler below,
			// or the gaps between the rows would close it.
			$(document).on('click', '[data-widget="info-bar"]', function(e) {
				e.stopPropagation();
			});

			$(document).on('click', function() {
				setOpen($bars.filter('.is-open'), false);
			});

			$(document).on('keydown', function(e) {
				if (e.key === 'Escape') setOpen($bars.filter('.is-open'), false);
			});

			// Sliding leaves an inline display behind. On desktop the same copy
			// is part of the static column, so a bar left closed on a phone must
			// not follow the viewport up and hide it.
			var mq = window.matchMedia(DESKTOP);

			function release() {
				if (!mq.matches) return;
				$bars.find('[data-js="info-panel"]').removeAttr('style');
			}

			if (mq.addEventListener) {
				mq.addEventListener('change', release);
			} else {
				mq.addListener(release);
			}

			release();
		}

		return { init: init };
	})();

	// ============================================
	// Select — the size / price dropdown
	// ============================================
	// HTML:
	//   <div class="dropdown" data-widget="select">
	//     <button data-js="select-toggle" aria-expanded="false">… current …</button>
	//     <div data-js="select-list"><ul>
	//       <button class="dropdown__option" data-price="100" data-size="10ml">…</button>
	//     </ul></div>
	//     <input type="hidden" name="size">
	//   </div>
	//
	// The layer is absolute, so opening it covers what follows rather than
	// pushing it down. jQuery owns the layer's display — the sheet states only
	// the shut position, and .is-open drives everything except display.
	var Select = (function() {
		var $all;

		function setOpen($sel, open) {
			$sel.each(function() {
				var $s = $(this);
				var $layer = $s.find('[data-js="select-list"]');
				if (open === $s.hasClass('is-open')) return;
				$s.toggleClass('is-open', open);
				$s.find('[data-js="select-toggle"]').attr('aria-expanded', open);
				$layer.toggle(open);
			});
		}

		// The chosen row's price and size replace the ones on the toggle, and the
		// hidden field carries the size into the form.
		function choose($select, $option) {
			var price = $option.data('price');
			var size = $option.data('size');

			$select.find('[data-js="select-toggle"] .dropdown__price')
				.html(price + '<span class="dropdown__unit"> aud</span>');
			$select.find('[data-js="select-toggle"] .dropdown__size').text(size);
			$select.find('input[name="size"]').val(size);

			$select.find('.dropdown__option').removeClass('is-current');
			$option.addClass('is-current');
		}

		function init() {
			$all = $('[data-widget="select"]');
			if (!$all.length) return;

			// 1 — the toggle opens this one and closes the rest
			$(document).on('click', '[data-js="select-toggle"]', function(e) {
				e.stopPropagation();
				var $s = $(this).closest('[data-widget="select"]');
				var open = !$s.hasClass('is-open');
				setOpen($all.not($s), false);
				setOpen($s, open);
			});

			// 2 — clicks inside the layer do not close it
			$(document).on('click', '[data-js="select-list"]', function(e) {
				e.stopPropagation();
			});

			// choosing a row closes it
			$(document).on('click', '.dropdown__option', function() {
				var $s = $(this).closest('[data-widget="select"]');
				choose($s, $(this));
				setOpen($s, false);
			});

			// 3 — a click anywhere else closes it. Both handlers sit on document, so
			// stopPropagation in the one above cannot stop this one — it asks where
			// the click landed instead. iOS only fires click on interactive elements,
			// hence pointerdown alongside it.
			$(document).on('click pointerdown', function(e) {
				if ($(e.target).closest('[data-widget="select"]').length) return;
				setOpen($all, false);
			});

			// 4 — Escape closes it
			$(document).on('keydown', function(e) {
				if (e.key === 'Escape') setOpen($all, false);
			});
		}

		return { init: init };
	})();

	// ============================================
	// Anchor Nav — scroll spy
	// ============================================
	// HTML:
	//   <nav class="anchor-nav" data-widget="anchor-nav">
	//     <a href="#section1" class="anchor-nav__link">Section 1</a>
	//     <a href="#section2" class="anchor-nav__link">Section 2</a>
	//   </nav>
	//   <section id="section1">...</section>
	//   <section id="section2">...</section>
	//
	// The active link carries .is-current, the same class the current page
	// link carries — one underline rule covers both.
	//
	// The jump itself is the browser's: every <a href="#id"> on the site works
	// on its own, lands on html's scroll-padding-top, writes the hash, and can
	// be reached, shared and stepped back through as a URL. This widget only
	// draws the active state, and reads the same line off the stylesheet so the
	// underline turns over exactly where a section comes to rest.
	//
	var AnchorNav = (function() {
		var $nav, $links, sections, ticking, $scroller;

		// On mobile the entries sit in their own scroller, so the resting line
		// and the end-of-list test read that element instead of the window.
		function scroller() {
			var el = $scroller && $scroller[0];
			return el && el.scrollHeight - el.clientHeight > 2 ? el : null;
		}

		// The one line every anchor on the site rests on.
		function getOffset() {
			return parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
		}

		function buildSections() {
			sections = [];
			$links.each(function() {
				var id = $(this).attr("href");
				var $el = $(id);
				if ($el.length) sections.push({ id: id, $el: $el, $link: $(this) });
			});
		}

		function setActive(id) {
			$links.removeClass("is-current");
			$links.filter('[href="' + id + '"]').addClass("is-current");
		}

		function onScroll() {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(function() {
				// One pixel of slack: the jump lands the section on exactly this
				// line, and sub-pixel rounding would otherwise leave the section
				// a hair short of its own resting place.
				var sc = scroller();
				var scrollTop = sc
					? sc.getBoundingClientRect().top + window.scrollY + 1
					: $(window).scrollTop() + getOffset() + 1;
				var current = null;

				for (var i = 0; i < sections.length; i++) {
					if (sections[i].$el.offset().top <= scrollTop) {
						current = sections[i].id;
					}
				}

				// The last section can sit short of the line forever — the page
				// runs out of scroll before it gets there — so the bottom of
				// the document counts as having reached it.
				var doc = document.documentElement;
				var atEnd = sc
					? sc.scrollHeight - sc.clientHeight - sc.scrollTop < 2
					: doc.scrollHeight - window.innerHeight - window.scrollY < 2;
				if (atEnd) {
					current = sections[sections.length - 1].id;
				}

				if (current) setActive(current);
				ticking = false;
			});
		}

		function init() {
			$nav = $('[data-widget="anchor-nav"]');
			if (!$nav.length) return;

			$links = $nav.find(".anchor-nav__link");
			ticking = false;

			buildSections();
			if (!sections.length) return;

			$scroller = sections[0].$el.parent();

			$(window).on("scroll", onScroll);
			$scroller.on("scroll", onScroll);
			onScroll();
		}

		return {
			init: init
		};
	})();

	// ============================================
	// Keyboard Mode
	// ============================================
	// Marks the document while the keyboard is driving, so focus rings show for
	// Tab / arrows / Escape and stay hidden for pointer and programmatic focus.
	var KeyboardMode = (function() {
		var KEYS = ["Tab", "Escape", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End", "PageUp", "PageDown"];

		function init() {
			var $html = $("html");

			$(document).on("keydown", function(e) {
				if ($.inArray(e.key, KEYS) !== -1) $html.addClass("is-keyboard");
			});

			$(document).on("pointerdown mousedown touchstart", function() {
				$html.removeClass("is-keyboard");
			});
		}

		return {
			init: init
		};
	})();

	// ============================================
	// Init
	// ============================================
	function init() {
		Header.init();
		PageState.init();
		Qty.init();
		InfoBar.init();
		Select.init();
		AnchorNav.init();
		KeyboardMode.init();
	}

	return {
		init: init
	};
})(jQuery);

$(function() {
	App.init();
});
